import { Box } from '@mui/material';
import type { ReactElement, ReactNode } from 'react';

import { BreadCrumbs } from '../BreadCrumbs/BreadCrumbs';

type PageProps = {
  title: string;
  children: ReactNode;
  pathMap?: { [key: string]: string };
};

export const Page = ({ title, children, pathMap }: PageProps): ReactElement => (
  <>
    <title>{title}</title>
    <main style={{ paddingLeft: '1.5rem', paddingRight: '1.5rem' }}>
      <Box paddingBottom='1rem'>
        <BreadCrumbs title={title} pathMap={pathMap} />
      </Box>
      {children}
    </main>
  </>
);
